// components/MethodSelector.jsx - Application Method Selection
import React from 'react'
import { 
  Droplets, TreePine, Pipette, Syringe, 
  CircleDot, Layers, Check 
} from 'lucide-react'

// Icon mapping for methods
const METHOD_ICONS = {
  foliar_spray: Droplets,
  soil_drench: Pipette,
  trunk_bark_spray: TreePine,
  trunk_injection: Syringe,
  soil_injection: CircleDot,
  granular_broadcast: Layers
}

export default function MethodSelector({ methods, selectedMethod, onSelect }) {
  return (
    <div className="p-4">
      <p className="text-sm text-gray-600 mb-4">
        Select how you're applying the pesticide
      </p>
      
      <div className="grid gap-3">
        {methods.map(method => {
          const Icon = METHOD_ICONS[method.id] || Droplets
          const isSelected = selectedMethod === method.id
          
          return (
            <button
              key={method.id}
              onClick={() => onSelect(method.id)}
              className={`method-card flex items-center gap-4 text-left ${isSelected ? 'selected' : ''}`}
            >
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                isSelected ? 'bg-arbor-500 text-white' : 'bg-gray-100 text-gray-500'
              }`}>
                <Icon className="w-6 h-6" />
              </div>
              
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">{method.name}</h3>
                <p className="text-sm text-gray-500">
                  {method.requiresCarrier ? 'Requires carrier/diluent' : 'No carrier required'}
                </p>
              </div>
              
              {isSelected && (
                <Check className="w-5 h-5 text-arbor-500" />
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
